import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Link} from 'react-router';

import classNames from 'classnames';

import {startDriving, openStory, closeStory} from '../../state/actions/timeline';

import CountDown from './CountDown';
import ImageSrcSet from '../ImageSrcSet';
import Body from './Body';
import EndOfStory from './EndOfStory';

import Icons from '../Shared/Icons';

import './DetailPage.scss';

class DetailPage extends Component {

    static contextTypes = {
        router: PropTypes.object.isRequired
    };

    render() {
        if (this.props.isDriving) return null;

        const className = classNames({
            "DetailPage__inner": true,
            "DetailPage__inner--open": this.props.open,
            "DetailPage__inner--menuOpen": this.props.isMenuOpen
        });

        const classNamePage = classNames({
            "DetailPage__pageWrapper": true,
            "DetailPage__pageWrapper--open": this.props.open
        });

        const classNameHeaderImage = classNames({
            "DetailPage__headerImage": true,
            "DetailPage__headerImage--open": this.props.open
        });

        const {title, image} = this.props.story;

        const header = this.buildHeader(title);
        const preview = this.buildPreview(this.props.story);
        const page = <Body body={this.props.story.body} />;

        return (
            <div className="DetailPage">

                    <div className={className}>
                        <div className={classNameHeaderImage}>
                            <ImageSrcSet {...image} />
                        </div>
                        <div className="DetailPage__body">
                            {header}
                            {preview}

                            <div className={classNamePage}>
                                {page}

                                <EndOfStory backButtonLabel={this.props.video.terugNaarRoadMovie} />
                            </div>

                        </div>
                    </div>

            </div>
        )
    }

    buildHeader() {
        const {title, location, readingTime} = this.props.story;

        return (
            <div className="DetailPage__header">
                <h1 className="DetailPage__title">{title}</h1>
                <div className="DetailPage__meta">
                    <div className="DetailPage__meta__location">
                        <Icons type="pin" color="green"/>

                        <label>{location.name}</label>
                    </div>
                    <div className="DetailPage__meta__readingTime">
                        <Icons type="clock" color="green"/>
                        <label>{readingTime}</label>
                    </div>
                </div>
            </div>
        )
    }

    buildPreview() {
        const className = classNames({
            "DetailPage__preview": true,
            "DetailPage__preview--open": this.props.open
        });

        const {rijVerder} = this.props.video;

        const {link, excerpt} = this.props.story;

        const countdown = this.props.open || this.props.isMenuOpen ? "8" : <CountDown countDownFinished={this.props.startDriving}/>;

        return (
            <div className={className}>
                <p className="DetailPage__excerpt">{excerpt}</p>
                <Link className="DetailPage__button" to={link.url}>{link.label}</Link>
                <div className="DetailPage__drive-link" onClick={() => this.props.startDriving()}>
                    <a className="active">{rijVerder} ({countdown} sec)</a>
                </div>
            </div>
        )
    }

}

function mapStateToProps({timeline, video}) {
    return {
        story: timeline.showStory,
        open: timeline.storyIsOpen,
        isMenuOpen: timeline.isMenuOpen,
        isDriving: timeline.isDriving,
        video
    }
}

export default connect(mapStateToProps, {startDriving, openStory, closeStory})(DetailPage);



// WEBPACK FOOTER //
// ./src/components/DetailPage/index.js